import React from "react";

const ArrowDown = (props) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg"
             height="20px"
             viewBox="0 -960 960 960"
             width="20px"
             fill="#e3e3e3"
             {...props}
        >
            <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/>
        </svg>
    )
}

export default ArrowDown;